import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { FgDamagesAdapter } from "./dto/fg-damages-adapter";
import { fgDamagesEntity } from "./dto/fg-damages-entity";
import { FgDamagesController } from "./fg-damages-controller";
import { FgDmagesService } from "./fg-damages-service";

@Module({

    imports:[TypeOrmModule.forFeature([fgDamagesEntity]),

],
controllers:[FgDamagesController],
providers:[FgDmagesService,FgDamagesAdapter,ApplicationExceptionHandler],
exports:[FgDmagesService],

})
export class FgDamagesModule{}